import React from 'react'
import Navbar from './Navbar'

function Dashboard() {
  return (
    <>
    <Navbar/>
      <div className="main-header">
      </div>
    </>
  )
}

export default Dashboard
